import { createClient, SupabaseClient } from '@supabase/supabase-js'
import { config } from './config'

let client: SupabaseClient | null = null

export function getSupabase(): SupabaseClient | null {
  if (!config.supabaseUrl || !config.supabaseAnonKey) return null
  if (!client) client = createClient(config.supabaseUrl, config.supabaseAnonKey)
  return client
}
